/**
 * @file 求人検索条件の保存
 *
 */
'use strict';

import Common from '../../Utils/Common'

/**
 * @classname BtnSaveFiltering
 * @classdesc 求人検索条件の保存
 */
export default class BtnSaveFiltering {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e, controller) {
		console.log('BtnSaveFiltering.constructor');
		this._$e = $e;
		this._controller = controller;
		this._$completeModal = $('#modal-save-filtering');
		this._$overlay = $('#overlay')
		this.isActive = false;
		this._$conditions = $('.conditions')
		this._$scope = $('.block--search.conditions')
		//検索条件タグ
		this._tags = this._$conditions.find('.list--gray-tag .list-item .text').map(function() {
			return $(this).text();
		})
		//検索タグが1つ以上あれば、保存ボタンをアクティブに
		if(this._tags.length > 0 ){
			this.isActive = true;
		}else {
			$e.addClass('disabled')
		}

		//ログイン中であればtrue
		this._logined = $('header').hasClass('login')

		this._$e.on('click', (e) => {
			e.preventDefault()
			if (this._$e.hasClass('disabled')) return
			this.onClick()
		})
		this._controller.on('saveFilteringComplete', () => this.onBtnSaveFilteringComplete());
		this._$completeModal.find('.btn').on('click', () => this.reload());
		this._$completeModal.on('shown.bs.modal', () => this.reload());
	};


	/**
	 * クリックのコールバック
	 *
	 * @memberof BtnSaveFiltering
	 * @return {undefined}
	 */
	onClick() {
		console.log('BtnSaveFiltering.onClick');

		console.log('BtnSaveFiltering.login::' + this._logined);
		console.log('BtnSaveFiltering.this.isActive::' + this.isActive);

		// ログインしていなければ、別ページに飛ぶ
		if(!this._logined) {
			const loginUrl = window.const.URL.LOGIN;
			location.href = `${loginUrl}`;
			return
		}

		//検索タグが1つ以上あれば、モーダルの中身を空にしてタグを再描画
		if(this.isActive ){
			this._$completeModal.find('.list--filtering').empty();
			this._tags.each((index, text) => {
				const $tag =  `<li class="list-item">${text}</li>`
				this._$completeModal.find('.list--filtering').append($tag)
			})
		}else{
			Common.showErrorModal('検索条件がありません。')
			return;
		}

		//APIで検索条件を送る
		this._controller.saveFiltering(Common.getApiSearchQuery(this._$scope));

	}


	/**
	 * 求人検索条件保存完了
	 *
	 * @memberof BtnSaveFiltering
	 * @return {undefined}
	 */
	onBtnSaveFilteringComplete() {
		console.log('BtnSaveFiltering.onBtnSaveFilteringComplete');
		this._$completeModal.fadeToggle('swing')
		this._$overlay.fadeToggle('swing')
	}


	/**
	 * リロード
	 *
	 * @memberof BtnSaveFiltering
	 * @return {undefined}
	 */
	reload() {
		console.log('BtnSaveFiltering.reload');
		location.reload();
	}
}
